import React, {Component} from 'react';
import {Modal} from 'antd';

class AccountLinkRoleSystem extends Component {
  confirm = () => {
    const {onOk, content, account} = this.props
    Modal.confirm({
      title: "Cài đặt quyền hệ thống",
      content: `Chắc chắn cài đặt quyền hệ thống cho tài khoản "${account.UserName}"?`,
      okText: 'Đồng ý',
      cancelText: 'Bỏ qua',
      onOk() {
        onOk(account)
      }
    });
  }
  render() {
    return (<span>
      <a onClick={this.confirm} style={{color: 'rgb(250, 140, 22)'}}>
        Quyền hệ thống
      </a>
    </span>);
  }
}

export default AccountLinkRoleSystem



// WEBPACK FOOTER //
// ./src/components/AccountLinkRoleSystem.js